import { s3Uploader } from "@everfi/reactifi";

export const s3NextUploader = async (files, url, parameters, onProgress) => {
  const file = files.length > 0 ? files[0] : files;
  const response = await fetch(`/admin/media/direct_post_json?aws_content_type=undefined&ext=jpg`, {
    method: 'GET',
    headers: {
      'X-CSRF-Token': document?.querySelector('meta[name=csrf-token]')?.content,
      'Content-Type': 'application/vnd.api+json',
      'Cache-Control': 'no-cache'
    },
    credentials: 'include'
  });
  const data = await response.json();
  await s3Uploader(file, data.formfields, data.url, onProgress);
  data.fileLocation = `${data.url}/${data.formfields.key.split('$')[0]}${file.name}`;
  return data;
};